// angular
// 	.module("HeroPRO")
// 	.factory("ActionItemsFactory", ActionItemsFactory);

/* @ngInject */
export default function ActionItemsFactory(HPConfig, $http, $location, raSpinnerService, $window) {
    /*= ========================================
	=            Private Functions            =
	========================================= */
    function handleSuccess(response) {
        if (raSpinnerService.isRegistered('todoListSpinner')) {
            raSpinnerService.hide('todoListSpinner');
        }

        if (response.data.Data === undefined) {
            return null;
        }

        return setupActionItems(response.data.Data);
    }

    function handleError(response) {
        return response.data;
    }

    function setupActionItems(actionItems) {
        for (let i = 0; i < actionItems.length; i++) {
            // Attach click handlers
            actionItems[i].click = createClickHandler(actionItems[i]);

            // Determine date to display
            actionItems[i].displayDate = setDisplayDate(actionItems[i]);

            actionItems[i].dismissed = actionItems[i].ActionItemStatusId === 5;
        }

        return actionItems;
    }

    function createClickHandler(actionItem) {
        let clickHandler;

        switch (actionItem.ActionItemTypeId) {
        case 1:
            clickHandler = function () {
                $location.url(`/app-detail/${actionItem.FundingRequestId}`);
            };
            break;
        case 2:
            clickHandler = function () {
                $location.url(`/app-detail/${actionItem.FundingRequestId}`);
            };
            break;
        case 3:
            clickHandler = function () {
                $location.url(`/app-detail/${actionItem.FundingRequestId}`);
            };
            break;
        case 4:
            clickHandler = function () {
                $location.url(`/app-detail/${actionItem.FundingRequestId}`);
            };
            break;
        case 5:
            clickHandler = function () {
                $location.url(`/app-detail/${actionItem.FundingRequestId}`);
            };
            break;
        case 6:
            clickHandler = function () {
                $location.url(`/app-detail/${actionItem.FundingRequestId}`);
            };
            break;
        default:
            clickHandler = function () {
                $window.alert('Cannot determine action item type ID. Please contact support.');
            };
            break;
        }

        return clickHandler;
    }

    function setDisplayDate(actionItem) {
        let displayDate;

        if (actionItem.DaysDueCount >= 1) {
            displayDate = 'Past Due';
        } else if (actionItem.DaysDueCount === 0) {
            displayDate = 'Due Today';
        } else if (actionItem.DaysDueCount === -1) {
            displayDate = 'Due Tomorrow';
        } else {
            displayDate = actionItem.DueDate;
        }

        return displayDate;
    }
    /* -----  End of Private Functions  ------*/


    /*= =======================================
	=            Public Functions            =
	======================================== */
    return {
        getActionItems(params) {
            if (raSpinnerService.isRegistered('todoListSpinner')) {
                raSpinnerService.show('todoListSpinner');
            }

            const request = $http({
                url: `${HPConfig.heroProApi}ActionItem/search`,
                method: 'GET',
                params,
            });

            return request.then(handleSuccess, handleError);
        },

        setActionItemStatus(params) {
            const request = $http({
                url: `${HPConfig.heroProApi}ActionItem/UpdateStatus`,
                method: 'POST',
                data: params,
            });

            return request.then(handleSuccess, handleError);
        },
    };
    /* -----  End of Public Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/actionItems/actionItemsFactory.js